import { render, staticRenderFns } from "./MsgInput.vue?vue&type=template&id=5ad10c69"
import script from "./MsgInput.vue?vue&type=script&lang=js"
export * from "./MsgInput.vue?vue&type=script&lang=js"
import style0 from "./MsgInput.vue?vue&type=style&index=0&id=5ad10c69&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports